import StatementSocketModel from 'models/sockets/statement-socket-model';
import { handleActions } from 'redux-actions';
import {
  initStatementSocketClient,
  setStatementSocketClient,
  clearSocketClientInStore,
  stopSocketConnection,
} from 'store/actions/statement-socket-actions';
import { setSocketDisconnectAction } from 'store/actions/action-creators';

export default handleActions(
  {
    [initStatementSocketClient]: (statementSocket, { payload }) => {
      return statementSocket.init({
        revisionId: payload.revisionId,
        projectId: payload.projectId,
        currentUserId: payload.currentUserId,
        geoCode: payload.geoCode,
        dispatch: payload.dispatch,
        currentUser: payload.currentUser,
      });
    },
    [setStatementSocketClient]: (statementSocket, { payload }) => {
      return statementSocket.setSocketClient(payload);
    },
    [setSocketDisconnectAction]: (statementSocket, { payload }) => {
      return statementSocket.setSocketDisconnect(payload);
    },
    [stopSocketConnection]: (statementSocket) => {
      return statementSocket.stopSocketConnection();
    },
    [clearSocketClientInStore]: (statementSocket, { payload }) => {
      return new StatementSocketModel();
    },
  },
  new StatementSocketModel(),
);
